import {
  GET_CIVILBUDGETCONTROLMATERIAL,
  GET_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  GET_CIVILBUDGETCONTROLMATERIAL_FAIL,
  DELETE_CIVILBUDGETCONTROLMATERIAL,
  DELETE_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  DELETE_CIVILBUDGETCONTROLMATERIAL_FAIL,
  UPDATE_CIVILBUDGETCONTROLMATERIAL,
  UPDATE_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  UPDATE_CIVILBUDGETCONTROLMATERIAL_FAIL,
  ADD_NEW_CIVILBUDGETCONTROLMATERIAL,
  ADD_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  ADD_CIVILBUDGETCONTROLMATERIAL_FAIL,
  CIVILBUDGETCONTROLMATERIAL_LOADING,
  CIVILBUDGETCONTROLMATERIAL_RESET
} from "./actionType";

export const resetCivilBudgetControlMaterialState = (actionType) => ({
  type: CIVILBUDGETCONTROLMATERIAL_RESET,
  payload: { actionType },
});

export const getCivilBudgetControlMaterialSuccess = (actionType, data) => ({
  type: GET_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  payload: { actionType, data },
});

export const getCivilBudgetControlMaterialFail = (actionType, error) => ({
  type: GET_CIVILBUDGETCONTROLMATERIAL_FAIL,
  payload: { actionType, error },
});

export const getCivilBudgetControlMaterial = data => ({
  type: GET_CIVILBUDGETCONTROLMATERIAL,
  payload: data,
});

export const getCivilBudgetControlMaterialLoading = () => ({
  type: CIVILBUDGETCONTROLMATERIAL_LOADING
});

export const deleteCivilBudgetControlMaterial = data => ({
  type: DELETE_CIVILBUDGETCONTROLMATERIAL,
  payload: data,
});

export const deleteCivilBudgetControlMaterialSuccess = data => ({
  type: DELETE_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  payload: data,
});

export const deleteCivilBudgetControlMaterialFail = error => ({
  type: DELETE_CIVILBUDGETCONTROLMATERIAL_FAIL,
  payload: error,
});

export const updateCivilBudgetControlMaterial = data => ({
  type: UPDATE_CIVILBUDGETCONTROLMATERIAL,
  payload: data,
});

export const updateCivilBudgetControlMaterialFail = error => ({
  type: UPDATE_CIVILBUDGETCONTROLMATERIAL_FAIL,
  payload: error,
});

export const updateCivilBudgetControlMaterialSuccess = data => ({
  type: UPDATE_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  payload: data,
});

export const addNewCivilBudgetControlMaterial = data => ({
  type: ADD_NEW_CIVILBUDGETCONTROLMATERIAL,
  payload: data,
});

export const addCivilBudgetControlMaterialSuccess = data => ({
  type: ADD_CIVILBUDGETCONTROLMATERIAL_SUCCESS,
  payload: data,
});

export const addCivilBudgetControlMaterialFail = error => ({
  type: ADD_CIVILBUDGETCONTROLMATERIAL_FAIL,
  payload: error,
});